import Transformer, { TRANSFORM_INPUT } from "+/Engine/Transformers/Transformer";
import DataTypes from "+/Engine/Helpers/DataTypes";

export default class Add extends Transformer {
  assertValidInput(value, params) {
    DataTypes.assertNumber(value);
    DataTypes.assertObject(params);
    DataTypes.assertObjectKeyExistsOfType("quantity", params, DataTypes.assertNumber);
  }

  [TRANSFORM_INPUT](value, params) {
    return value + params.quantity;
  }
}
Transformer.register("add", Add);
